import React, { PureComponent } from 'react';
import sessionStore, { watchSessions, unwatchSessions } from 'data/session';
import storeConnect from 'data/store-connect';
import { ISession } from 'types';
import SessionItem from 'components/session/session-item';
import { ICON_ADD } from 'icons';
import FabButton from 'ui/button/fab-button';
import { SessionCreate } from 'components/session';
import { RouteComponentProps } from 'react-router-dom';
import Card from 'ui/card';
import { TextField, SelectField, SelectItemField } from 'ui/form';
import memoize from 'memoize-one';
// Components
const CARD_SIZE = {
  width: 450,
  height: 400
};

interface ListProps extends RouteComponentProps {
  list: ISession[];
}
const storeMap = {
  list: () => sessionStore.list
};
@storeConnect(storeMap, [sessionStore])
class SessionList extends PureComponent<ListProps> {
  state = {
    sort: 'created'
  };

  list = memoize((list: ISession[], query: string, sort: string) => {
    if (query) {
      const terms = query
        .split(/\s+/)
        .map(term => `(?=.*${term})`)
        .join('');

      const reg = new RegExp(terms, 'i');
      list = list.filter(item => reg.test(item.name));
    }
    return list.sort((i1, i2) => {
      console.log('sort', i1.creator);
      switch (sort) {
        case 'name':
          return i1.name < i2.name ? -1 : 1;
        case 'created':
          return i2.created - i1.created;
        case 'createdBy':
          return i1.creator < i2.creator ? -1 : 1;
      }
    });
  });

  componentDidMount() {
    watchSessions();
  }

  componentWillUnmount() {
    unwatchSessions();
  }

  handleQuery = query => this.setState({ query });
  handleSort = sort => this.setState({ sort });

  render() {
    const { list, history } = this.props;
    const { sort, query } = this.state;
    return (
      <div className="column">
        <div className="padding row">
          <div className="margin flex">
            <TextField label="Search" fullWidth hideNote onChange={this.handleQuery} />
          </div>
          <div className="margin" style={{ width: 300 }}>
            <SelectField label="Sort by" value={sort} hideNote onChange={this.handleSort}>
              <SelectItemField value="created" label="Created" />
              <SelectItemField value="name" label="Session name" />
              <SelectItemField value="createdBy" label="Created by" />
            </SelectField>
          </div>
        </div>
        <div className=" flex row wrap h-center padding">
          <SessionCreate style={CARD_SIZE} />
          {this.list(list, query, sort)
            .filter(s => !s.deleted)
            .map(session => (
              <SessionItem
                onClick={() => history.push(`/session/${session.key}`)}
                key={session.key}
                style={CARD_SIZE}
                className="margin"
                session={session}
              />
            ))}
          <FabButton icon={ICON_ADD} link="/session/create" />
        </div>
      </div>
    );
  }
}
export default SessionList;
